import { NotificationType } from 'modules/core/domain/interfaces/supabase/notifications/types';
import type { UDStatusTone } from 'ud-ui/components/status-tone';

/**
 * Единственная таблица «тип → тон»: исправление — красный, то, что требует внимания, — жёлтый, обновление —
 * зелёный, остальное — нейтральный. Тон красит плитку типа (`UDIconTile`, цвета из `status-tone` кита); бейдж
 * типа нейтральный, цвета у него нет: тип — категория, а не исход.
 */
export const typeToneMap: Record<NotificationType, UDStatusTone> = {
  update: 'success',
  bugfix: 'error',
  maintenance: 'pending',
  info: 'neutral',
  upcoming: 'neutral',
  known_issue: 'pending',
  user_event: 'neutral',
};
